import {BaseContainerModel} from '../../base-container.model';
import {
  bl_aat_entitlement_auto_top_up_event_filter_company_RowClass,
  bl_aat_entitlement_auto_top_up_event_filter_job_role_RowClass,
  bl_aat_entitlement_auto_top_up_event_RowClass,
} from '../../../dbschema';

export class ClaimEntitlementAutoTopUpEventContainerModel extends BaseContainerModel {
  bl_aat_entitlement_auto_top_up_event: bl_aat_entitlement_auto_top_up_event_RowClass =
    new bl_aat_entitlement_auto_top_up_event_RowClass();
}

export class ClaimEntitlementAutoTopUpEventCustomContainerModel extends BaseContainerModel {
  bl_aat_entitlement_auto_top_up_event: bl_aat_entitlement_auto_top_up_event_RowClass =
    new bl_aat_entitlement_auto_top_up_event_RowClass();

  bl_aat_entitlement_auto_top_up_event_filter_companies: bl_aat_entitlement_auto_top_up_event_filter_company_RowClass[] = [];
  bl_aat_entitlement_auto_top_up_event_filter_job_roles: bl_aat_entitlement_auto_top_up_event_filter_job_role_RowClass[] = [];
}
